<template >
  <section class="bg-white py-4 px-4 mt-4 rounded-[4px] flex justify-center">
    <div class="relative">
      <circle
        @click="previousSlide()"
        class="bg-white h-6 w-6 rounded-full absolute top-1/2 -mt-3 ml-2 z-10"
        ><Icon name="SetaEsquerda"
      /></circle>
      <circle
        @click="nextSlide()"
        class="
          bg-white
          h-6
          w-6
          rounded-full
          absolute
          top-1/2
          -mt-3
          mr-2
          right-0
          z-10
        "
        ><Icon name="SetaDireita"
      /></circle>

      <div class="relative overflow-hidden">
        <div
          class="
            inset-0
            transition-all
            ease-in-out
            duration-1000
            transform
            translate-x-0
            slide
          "
        >
          <RadialProgress />
        </div>
      </div>

      <div
        class="bg-white absolute left-1/2 bottom-0 -ml-6 rounded-full mb-3.5"
      >
        <div class="grid grid-flow-col gap-[5px] px-[9px] py-1">
          <circle class="h-2 w-2 bg-primary rounded-full dot-index"></circle>
          <circle class="h-2 w-2 bg-highlight rounded-full dot-index"></circle>
          <circle class="h-2 w-2 bg-highlight rounded-full dot-index"></circle>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import RadialProgress from "@/Components/UI/Dashboard/RadialProgress.vue";

export default {
  components: {
    Icon,
    RadialProgress,
  },
  methods: {
    nextSlide() {
      let activeSlide = document.querySelector(".slide.translate-x-0");
      let activeDotIndex = document.querySelector(".bg-primary.dot-index");

      if (activeSlide.nextElementSibling) {
        activeSlide.classList.remove("translate-x-0");
        activeSlide.classList.add("-translate-x-full");
        activeDotIndex.classList.remove("bg-primary");
        activeDotIndex.classList.add("bg-highlight");

        let nextSlide = activeSlide.nextElementSibling;
        let nextDotIndex = activeDotIndex.nextElementSibling;

        nextSlide.classList.remove("translate-x-full");
        nextSlide.classList.add("translate-x-0");
        nextDotIndex.classList.remove("bg-highlight");
        nextDotIndex.classList.add("bg-primary");
      }
    },
    previousSlide() {
      let activeSlide = document.querySelector(".slide.translate-x-0");
      let activeDotIndex = document.querySelector(".bg-primary.dot-index");

      if (activeSlide.previousElementSibling) {
        activeSlide.classList.remove("translate-x-0");
        activeSlide.classList.add("translate-x-full");
        activeDotIndex.classList.remove("bg-primary");
        activeDotIndex.classList.add("bg-highlight");

        let previousSlide = activeSlide.previousElementSibling;
        let previousDotIndex = activeDotIndex.previousElementSibling;
        previousSlide.classList.remove("-translate-x-full");
        previousSlide.classList.add("translate-x-0");
        previousDotIndex.classList.remove("bg-highlight");
        previousDotIndex.classList.add("bg-primary");
      }
    },
  },
};
</script>
